import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import {
  HandleFileDirective,
  ToUpperCaseDirective,
  WebsocketService,
  NumberDirective,
  NoAutocompleteDirective,
  MaxDirective,
  TextDirective,
  FormFieldClickableDirective,
} from './';
import { IPOnlyDirective } from './utils/ip-only.directive';

@NgModule({
  imports: [NumberDirective, IPOnlyDirective, FormFieldClickableDirective],
  declarations: [
    HandleFileDirective,
    ToUpperCaseDirective,
    NoAutocompleteDirective,
    MaxDirective,
    TextDirective,
  ],
  providers: [WebsocketService],
  exports: [
    HandleFileDirective,
    ToUpperCaseDirective,
    NoAutocompleteDirective,
    MaxDirective,
    TextDirective,
    FormFieldClickableDirective,
  ],
  entryComponents: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
